import { removeSharedFolderUser } from '../actions/removeSharedFolderUser';
import { removeSharedFolderUserEmail } from '../actions/removeSharedFolderUserEmail';
import removeSharedFoldersService from '../services/removeSharedFoldersService';
import { logUsage } from 'owa-analytics';
import { removeFolderTreeData } from 'owa-folders';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';

/**
 * Orchestrator that removes the shared folder user
 */
export default orchestrator(removeSharedFolderUser, async actionMessage => {
    const { principalSMTPAddress } = actionMessage;
    let response;
    try {
        response = await removeSharedFoldersService(principalSMTPAddress);
    } catch (error) {
        trace.error('Remove shared folders server call failed with error ' + error);
    }
    if (response) {
        removeSharedFolderUserEmail(principalSMTPAddress);
        removeFolderTreeData(principalSMTPAddress);
        logUsage('Triage_SharedFolders_RemoveFolder');
    } else {
        trace.error('Remove shared folders server call returned false');
    }
});
